import React from 'react';
import ReviewCard from '../ReviewCard';
import styles from './reviewCardListStyles.module.scss';
import { ProductReview, ProductReviewFeedbacks } from '../../../types/reviews';
import { getProductReviewFeedbackCookieValue } from 'src/scripts/utils/reviews';

const ReviewCardList = ({
  productReviews,
  loading,
  onClearAllProductReviewFilters,
}: {
  productReviews: ProductReview[];
  loading: boolean;
  onClearAllProductReviewFilters: () => void;
}) => {
  if (productReviews.length <= 0 && !loading) {
    return (
      <div className={styles.noReviewsContainer}>
        <p className={styles.noReviewsMessage}>
          <span>
            <span className={styles.aloAlertIcon}></span>
          </span>
          <span className="body-small semibold red notranslate">
            Sorry there are no reviews with your current filters
          </span>
          <button
            onClick={onClearAllProductReviewFilters}
            className={`${styles.clearAllButton} body-text-link-small red notranslate`}
          >
            Clear All
          </button>
        </p>
      </div>
    );
  } else {
    const feedbacks: ProductReviewFeedbacks = getProductReviewFeedbackCookieValue();

    return (
      <ul className={styles.reviewCardList}>
        {productReviews.map((productReview, idx) => (
          <li key={idx} className={styles.reviewCardListItem}>
            <ReviewCard data={productReview} feedbacks={feedbacks} />
          </li>
        ))}
      </ul>
    );
  }
};

export default ReviewCardList;
